import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { type ComponentProps, type ReactNode } from 'react';

import { HolidayLogo } from '../../../assets/Holidays/HolidayLogo';
import { LogoDestination, LogoSizes } from '../../../assets/Logo/Logo';
import { theme } from '../../../theme/theme';

const LogosContainer = styled.div`
	display: inline-flex;
	align-items: center;
`;

const Divider = styled.div`
	inline-size: 1px;
	align-self: stretch;
	margin-block: -2px;
	background: currentColor;
	margin-inline: ${theme.paddings.xs};
	opacity: 0.5;
	border-radius: ${theme.border.radii.sm};
`;

export interface HeaderLogosProps {
	readonly headerLogoLink?: LogoDestination;
	readonly coBrandingLogo?: ReactNode;
	readonly disableForwardToPage?: boolean;
}

export const HeaderLogos = observer(function HeaderLogos({
	headerLogoLink = LogoDestination.Schedule,
	coBrandingLogo = null,
	disableForwardToPage = false,
}: HeaderLogosProps) {
	const logoProps = {
		size: LogoSizes.Base,
		destination: headerLogoLink,
		disableForwardToPage,
	} as const satisfies ComponentProps<typeof HolidayLogo>;

	const maybeCoBrandingLogo = coBrandingLogo ? (
		<>
			{coBrandingLogo}
			<Divider />
		</>
	) : null;

	return (
		<LogosContainer>
			{maybeCoBrandingLogo}
			<HolidayLogo {...logoProps} />
		</LogosContainer>
	);
});
